<template>
  <div class="min-h-screen flex flex-col">
    <div class="px-4 pt-6 pb-4">
      <div class="flex items-center justify-between">
  <button class="inline-flex items-center justify-center bg-primary text-white rounded-[0.625rem] w-10 h-10" @click="goBack" aria-label="Назад">
          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none"><path d="M8 15L1 8L8 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
  <LogoIcon />
        <div class="w-10 h-10"></div>
      </div>
    </div>
    <div class="px-4 mb-4">
      <h1 class="text-[1.5625rem] font-bold text-primary">Мой заказ</h1>
    </div>
    <div class="bg-primary text-white rounded-t-[1.875rem] justify-between shadow-[0_-5px_20px_0_rgba(76,95,143,0.10)] flex-1 flex flex-col">
      <div class="p-6 space-y-6 overflow-y-auto flex-1">
        <template v-if="cartItems.length">
          <div v-for="item in cartItems" :key="item._key || (item.id + (item.selectedColor||'') + (item.selectedSize||''))" class="pb-6">
            <div class="flex items-start gap-4">
              <div class="w-20 h-20 rounded-lg overflow-hidden bg-white flex items-center justify-center">
                <img :src="buildImageSrc(item)" :alt="item.name" class="max-h-full object-contain" />
              </div>
              <div class="flex-1 min-w-0">
                <span class="text-sm font-semibold leading-snug mb-1 break-words">{{ item.name }}</span>
                <div v-if="item.selectedOptions && Object.keys(item.selectedOptions).length" class="text-xs text-white/70 font-medium mb-2">
                  <span v-for="(value, key) in item.selectedOptions" :key="key" class="mr-3">
                    {{ key }}: <span class="text-white">{{ value }}</span>
                  </span>
                </div>
                <!-- Legacy fallback for old cart items -->
                <div v-else-if="item.selectedColor || item.selectedSize" class="text-xs text-white/70 font-medium space-x-2 mb-2">
                  <span v-if="item.selectedColor">Цвет: <span class="text-white">{{ item.selectedColor }}</span></span>
                  <span v-if="item.selectedSize">Размер: <span class="text-white">{{ item.selectedSize }}</span></span>
                </div>
                <div class="flex items-center gap-4 mt-2">
                  <div class="flex items-center bg-white/10 rounded-md">
                    <button @click="decrement(item)" class="w-8 h-8 flex items-center justify-center text-lg leading-none">-</button>
                    <span class="w-8 text-center text-sm">{{ item.quantity }}</span>
                    <button @click="increment(item)" class="w-8 h-8 flex items-center justify-center text-lg leading-none">+</button>
                  </div>
                  <p class="text-base font-bold">{{ formatPrice(item.price_preview || item.price) }} ₽</p>
                </div>
              </div>
              <button @click="remove(item)" class="text-white/50 hover:text-white transition" aria-label="Удалить">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3.5 4.5H12.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.8337 4.5V12.1667C11.8337 12.5203 11.6932 12.8594 11.4431 13.1094C11.1931 13.3595 10.854 13.5 10.5003 13.5H5.50033C5.1467 13.5 4.80756 13.3595 4.55752 13.1094C4.30747 12.8594 4.16699 12.5203 4.16699 12.1667V4.5M6.5 4.5V3.16667C6.5 2.98986 6.57024 2.82029 6.69526 2.69526C6.82029 2.57024 6.98986 2.5 7.16667 2.5H8.83333C9.01014 2.5 9.17971 2.57024 9.30474 2.69526C9.42976 2.82029 9.5 2.98986 9.5 3.16667V4.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </button>
            </div>
            <div class="h-px bg-white/15 mt-6" v-if="item !== cartItems[cartItems.length-1]"></div>
          </div>
        </template>
        <div v-else class="text-center py-10 text-white/60 text-sm">Корзина пуста</div>
      </div>
      <div class="p-6  border-t border-white/10">
        <div v-if="pickupPoints.length" class="mb-4">
          <label class="block text-sm font-medium text-white/70 mb-2">Пункт выдачи</label>
          <select
            v-model="selectedPickupPointId"
            class="w-full h-10 px-3 rounded-md bg-white/10 text-white text-sm border border-white/20 focus:outline-none focus:border-accent"
          >
            <option :value="null" disabled class="text-primary">Выберите пункт выдачи</option>
            <option
              v-for="pp in pickupPoints"
              :key="pp.id"
              :value="pp.id"
              class="text-primary"
            >
              {{ pp.name || pp.address || `Пункт #${pp.id}` }}
            </option>
            <option :value="0" class="text-primary">Я работаю в другом городе</option>
          </select>
          <div v-if="selectedPickupPointId === 0" class="mt-3">
            <label class="block text-sm font-medium text-white/70 mb-2">Адрес пункта самовывоза</label>
            <textarea
              v-model="customPickupAddress"
              maxlength="255"
              rows="2"
              placeholder="Укажите адрес (до 255 символов)"
              class="w-full px-3 py-2 rounded-md bg-white/10 text-white text-sm border border-white/20 focus:outline-none focus:border-accent resize-none"
            />
          </div>
        </div>
        <div class="flex items-center justify-between mb-4">
          <span class="text-sm font-medium text-white/70">Итого</span>
          <span class="text-xl font-bold">{{ totalPrice }} ₽</span>
        </div>
        <div v-if="checkoutError" class="mb-3 text-sm text-red-300">{{ checkoutError }}</div>
        <div v-if="checkoutSuccess" class="mb-3 text-sm text-green-300">Заказ оформлен! №{{ checkoutSuccess }}</div>
        <button
          class="w-full h-12 bg-accent rounded-lg font-semibold text-white text-base disabled:opacity-50"
          :disabled="!canCheckout"
          @click="checkout"
        >
          <span v-if="checkoutLoading">Оформляем…</span>
          <span v-else>Оформить заказ</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { API_CONFIG } from '@/config'
import api from '@/services/api'
import LogoIcon from './LogoIcon.vue'
export default {
  name: 'CartPage',
  components: { LogoIcon },
  props: {
    cartItems: { type: Array, default: () => [] }
  },
  emits: ['back','remove-item','checkout','clear-cart','order-created'],
  data(){
    return {
      imagesBaseUrl: API_CONFIG?.staticBaseUrl || '',
      pickupPoints: [],
      selectedPickupPointId: null,
      checkoutLoading: false,
      checkoutError: '',
      checkoutSuccess: null,
      customPickupAddress: ''
    }
  },
  computed: {
    totalPrice(){
      return this.cartItems.reduce((s,i)=> s + ((i.price || i.price_preview || 0) * (i.quantity || 1)), 0).toFixed(2)
    },
    canCheckout(){
      if (this.checkoutLoading) return false
      if (!this.cartItems.length) return false
      if (this.pickupPoints.length && this.selectedPickupPointId == null) return false
      if (this.selectedPickupPointId === 0 && !this.customPickupAddress.trim()) return false
      if (this.cartItems.some(i => !i.variantId)) return false
      return true
    }
  },
  methods: {
    goBack(){ if(this.$router){ this.$router.push({ name: 'catalog' }) } else { this.$emit('back') } },
    formatPrice(v){
      if (v == null) return '0.00'
      return Number(v).toFixed(2)
    },
    buildImageSrc(item){
      if(!item) return ''
      const raw = item.image || item.image_url || item.img || ''
      if(!raw) return this.imagesBaseUrl + 'placeholder.png'
      if(/^(https?:|data:)/i.test(raw)) return raw
      return this.imagesBaseUrl + raw
    },
    increment(item){ item.quantity = (item.quantity || 1) + 1 },
    decrement(item){ item.quantity = Math.max(1, (item.quantity || 1) - 1) },
    remove(item){ this.$emit('remove-item', item) },
    async fetchPickupPoints(){
      try {
        const resp = await api.get('pick_up_points', { params: { size: 50 } })
        this.pickupPoints = resp.data?.items || []
        if (this.pickupPoints.length && !this.selectedPickupPointId){
          this.selectedPickupPointId = this.pickupPoints[0].id
        }
      } catch (e) {
        console.error('Не удалось загрузить пункты выдачи', e)
      }
    },
    async checkout(){
      if (!this.canCheckout) return
      this.checkoutLoading = true
      this.checkoutError = ''
      this.checkoutSuccess = null
      try {
        const order_lines = this.cartItems.map(i => ({
          product_var_id: Number(i.variantId),
          quantity: i.quantity || 1,
          options: i.selectedOptions || {}
        }))
        const isOtherCity = this.selectedPickupPointId === 0
        const payload = {
          order_lines,
          pickup_point_id: isOtherCity ? null : this.selectedPickupPointId,
          comment: isOtherCity ? `Пунк самовывоза:\n'${this.customPickupAddress.trim()}'` : null
        }
        const resp = await api.post('orders', payload)
        this.checkoutSuccess = resp.data?.id || '✓'
        this.customPickupAddress = ''
        this.$emit('clear-cart')
        this.$emit('order-created', resp.data)
      } catch (e) {
        const status = e.response?.status
        const detail = e.response?.data?.detail
        if (status === 401) {
          this.checkoutError = 'Откройте каталог из бота, чтобы оформить заказ.'
        } else if (Array.isArray(detail)) {
          this.checkoutError = detail.map(d => d.msg || d).join(', ')
        } else if (typeof detail === 'string') {
          this.checkoutError = detail
        } else if (detail && detail.message) {
          this.checkoutError = detail.message
        } else if (status === 422) {
          this.checkoutError = 'Не удалось оформить заказ. Проверьте наличие баллов и попробуйте снова.'
        } else {
          this.checkoutError = 'Не удалось оформить заказ. Попробуйте ещё раз.'
        }
      } finally {
        this.checkoutLoading = false
      }
    }
  },
  mounted(){
    this.fetchPickupPoints()
  }
}
</script>

<style scoped>
::-webkit-scrollbar { width: 6px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.15); border-radius: 3px; }
</style>
